import { render, staticRenderFns } from "./AverageRating.vue?vue&type=template&id=4324a73e&"
import script from "./AverageRating.vue?vue&type=script&lang=js&"
export * from "./AverageRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports